import { render, staticRenderFns } from "./Synopsis.vue?vue&type=template&id=287010c5&scoped=true"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"
import style0 from "./Synopsis.vue?vue&type=style&index=0&id=287010c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287010c5",
  null
  
)

export default component.exports